import { render, staticRenderFns } from "./UpdateStatusPopoverItem.vue?vue&type=template&id=4289093c&"
import script from "./UpdateStatusPopoverItem.vue?vue&type=script&lang=js&"
export * from "./UpdateStatusPopoverItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports